import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { NgxSoapService, Client } from 'ngx-soap';

import { TeslSchema } from './tesl-schema';
import { environment } from '../environments/environment';
import { CommonService} from './common.service';
@Injectable({
  providedIn: 'root'
})
export class TeslService {

  private sessionClient: Client
  private policyWorkflowClient: Client
  private objectAccessClient: Client
  private workflowClient: Client
  private sessionId: undefined;
  private contextObjectId: undefined;
  private ATTRIBUTEKEY = 'attributes';

  public objectIDs: object = {};
  public baseUrl: string;

  constructor(private http: HttpClient, private soap: NgxSoapService) {
    this.baseUrl = environment.serverURL;
  }

  setObjectIDFromAttributes(attrs) {
    var object_name = attrs['os_id'].split("_")[0]
    this.objectIDs[object_name] = attrs;
  }

  /**
   * Saves all object ids. Recursively
   *
   * @param      {<type>}  data    The data
   * @return     {<type>}  None
   */
  saveAllObjectIDs(data) {
    for (var child in data) {
      if (typeof data[child] === 'object') {
        if (this.ATTRIBUTEKEY in data[child]) {
          this.setObjectIDFromAttributes(data[child][this.ATTRIBUTEKEY])
        }
        this.saveAllObjectIDs(data[child]);
      }
    }
  }

  updatePayloadWithObjectIDs(data) {
    for (var child in data) {
      if (typeof data[child] === 'object') {
        if (this.objectIDs[child] != undefined) {
          data[child][this.ATTRIBUTEKEY] = this.objectIDs[child];
        }
        else{
        }
        this.updatePayloadWithObjectIDs(data[child]);
      }
    }
  }

  logResult(name, operation) {
    // console.log(name, 'operation', operation.result.return)
    console.log('***', name, 'IS_SUCCESS', operation.result.return.status.code === 0)
  }

  getSessionServiceWSDL() {
    var promise = new Promise((resolve, reject) => {
      if (!this.sessionClient) {
        this.soap.createClient("/DisWeb/services/SessionService?wsdl", { responseType: "text" }).then(response => {
          this.sessionClient = response
          resolve();
        });
      } else {
        resolve();
      }
    })
    return promise;
  }

  getPolicyWorkflowServiceWSDL() {
    var promise = new Promise((resolve, reject) => {
      if (!this.policyWorkflowClient) {
        this.soap.createClient("/DisWeb/services/PolicyWorkflowService?wsdl", { responseType: "text" }).then(response => {
          this.policyWorkflowClient = response
          resolve();
        });
      } else {
        resolve();
      }
    })
    return promise;
  }

  getObjectAccessServiceWSDL() {
    var promise = new Promise((resolve, reject) => {
      if (!this.objectAccessClient) {
        this.soap.createClient("/DisWeb/services/ObjectAccessService?wsdl", { responseType: "text" }).then(response => {
          this.objectAccessClient = response
          resolve();
        });
      } else {
        resolve();
      }
    })
    return promise;
  }

getWorkflowServiceWSDL() {
    var promise = new Promise((resolve, reject) => {
      if (!this.workflowClient) {
        this.soap.createClient("/DisWeb/services/WorkflowService?wsdl", { responseType: "text" }).then(response => {
          this.workflowClient = response
          resolve();
        });
      } else {
        resolve();
      }
    })
    return promise;
  }

  createSession() {
    return new Promise((resolve, reject) => {
      this.getSessionServiceWSDL().then(() => {
        this._createSession(resolve, reject)
      })
    })
  }

  _createSession(resolve, reject) {
    var body = {
      request: {
        exchangeId: 1218,
        operationLabel: "createSession",
        partnerId: 0,
        userName: "ll",
        password: "ll",
        systemId: "oneShield",
        serviceOpInvocationId: "1111111"
      }
    }

    var observable = this.sessionClient.call("createSession", body)
    observable.subscribe(operation => {
      this.logResult('createSession', operation)
      this.sessionId = operation.result.return.sessionId
      // console.log('sessionId', this.sessionId)
      resolve()
    });
    return observable;
  }

  initiateQuote(payload_initial) {
    return new Promise((resolve, reject) => {
      this.getPolicyWorkflowServiceWSDL().then(() => {
        this._initiateQuote(resolve, reject, payload_initial)
      })
    })
  }

  _initiateQuote(resolve, reject, payload) {
    var body = {
      request: {
        "payload": this.policyWorkflowClient.wsdl.objectToXML(payload, ""),
        "operationLabel": "initiateQuote",
        "serviceOpInvocationId": "ikk",
        "sessionId": this.sessionId
      }
    }

    this.policyWorkflowClient.call("initiateQuote", body).subscribe(operation => {
      this.logResult('initiateQuote', operation)
      this.contextObjectId = operation.result.return.contextObjectId
      resolve()
    })
  }

  readObject() {
    return new Promise((resolve, reject) => {
      this.getObjectAccessServiceWSDL().then(() => {
        this._readObject(resolve, reject)
      })
    })
  }

  _readObject(resolve, reject) {
    var body = {
      request: {
        "contextObjectId": this.contextObjectId,
        "operationLabel": "getQuote",
        "serviceOpInvocationId": "12",
        "sessionId": this.sessionId
      }
    }

    var obs = this.objectAccessClient.call("readObject", body)
    obs.subscribe(operation => {
      this.logResult('readObject', operation)
      //if (operation.result.return['success'] === 0 && 'payload' in operation.result.return) {
        var payload = this.objectAccessClient.wsdl.xmlToObject(operation.result.return['payload'])
        this.saveAllObjectIDs(payload);
        resolve(payload)
      //}
    })
    return obs
  }

  rate(common_service = null, reflect_values) {
    return new Promise((resolve, reject) => {
      this.getPolicyWorkflowServiceWSDL().then(() => {
        this._rate(resolve, reject, common_service, reflect_values)
      })
    })
  }

  _rate(resolve, reject, common_service, reflect_values) {
    var body = {
      request: {
        "contextObjectId": this.objectIDs["PolicyTransactionPolicy"]["os_st_id"],
        "operationLabel": "rateQuote",
        "serviceOpInvocationId": "ikk",
        "sessionId": this.sessionId
      }
    }

    var obs = this.policyWorkflowClient.call("rate", body)
    obs.subscribe(operation => {
      this.logResult('rate', operation)

      var payload = this.objectAccessClient.wsdl.xmlToObject(operation.result.return['payload'])
      if(reflect_values){
        if(CommonService.coverage[0] != null)
          CommonService.coverage[0].initial_price = this.getInitialPriceValue(+payload['PolicyTransactionPolicy']['PropertyCoverage'] + +payload['PolicyTransactionPolicy']['ContentsCoverage'], CommonService.coverage[0].range.min, CommonService.coverage[0].initial_coverage);
        
        if(CommonService.coverage[1] != null)
        CommonService.coverage[1].initial_price = this.getInitialPriceValue(+payload['PolicyTransactionPolicy']['WorkersCompensation'], CommonService.coverage[1].range.min, CommonService.coverage[1].initial_coverage);
       
        if(CommonService.coverage[2] != null)
          CommonService.coverage[2].initial_price = this.getInitialPriceValue(+payload['PolicyTransactionPolicy']['DeliveryLiability'], CommonService.coverage[2].range.min, CommonService.coverage[2].initial_coverage);
        
        if(CommonService.coverage[3] != null)
          CommonService.coverage[3].initial_price = this.getInitialPriceValue(+payload['PolicyTransactionPolicy']['InlandMarine'], CommonService.coverage[3].range.min, CommonService.coverage[3].initial_coverage);
       
        if(CommonService.coverage[4] != null)
        CommonService.coverage[4].initial_price = this.getInitialPriceValue(+payload['PolicyTransactionPolicy']['CyberCoverage'], CommonService.coverage[4].range.min, CommonService.coverage[4].initial_coverage);
       
        if(CommonService.coverage[5] != null)
          CommonService.coverage[5].initial_price = this.getInitialPriceValue(+payload['PolicyTransactionPolicy']['GeneralLiability'], CommonService.coverage[5].range.min, CommonService.coverage[5].initial_coverage);
        
        this.checkCoverageValues()
        CommonService.calculatePrice();
        if(common_service != null){ 
          // remove the coverages with 0 or nan premium     
          CommonService.removeUnwantedCoverages(common_service);
          // common_service.changeOptions(CommonService.filtered_coverage);
          // common_service.changeTotalCoverage(CommonService.filtered_total);
          // common_service.changeAllCoverage(CommonService.coverage);
        }

        CommonService.filer_coverage_values();
        // CommonService.total_filtered_values();
        // CommonService.filtered_total = +payload['PolicyTransactionPolicy']['Premium']; 

        //change the values of filtered coverages and change the total of the new filtered list
        common_service.changeOptions(CommonService.filtered_coverage);
        common_service.changeTotalCoverage(CommonService.filtered_total);
        // change the value of coverage all 
        common_service.changeAllCoverage(CommonService.coverage);
      }
      resolve();
    })
    return obs
  }


  getInitialPriceValue(rec_price, min_coverage, current_coverage){
    return rec_price*min_coverage.replace(/,/g, "")/current_coverage.replace(/,/g, "");
    // return rec_price;
  }

  checkCoverageValues(){
     for(let i = 0;i<CommonService.coverage.length; i++){
       if((CommonService.coverage[i].initial_price+"").toLowerCase() == "nan"){
         CommonService.coverage[i].initial_price = 0.0;
       }
     }
  }
  bindPolicy() {
    return new Promise((resolve, reject) => {
      this.getPolicyWorkflowServiceWSDL().then(() => {
        this._bindPolicy(resolve, reject)
      })
    })
  }

  _bindPolicy(resolve, reject) {
    var body = {
      request: {
        "contextObjectId": this.objectIDs["PolicyTransactionPolicy"]["os_st_id"],
        "operationLabel": "bindPolicy",
        "serviceOpInvocationId": "ikk",
        "sessionId": this.sessionId
      }
    }

    var obs = this.policyWorkflowClient.call("bindPolicy", body)
    obs.subscribe(operation => {
      this.logResult('bindPolicy', operation)
      var payload = this.objectAccessClient.wsdl.xmlToObject(operation.result.return['payload'])
      resolve(payload)
    })
    return obs
  }

  executeWorkflow() {
    return new Promise((resolve, reject) => {
      this.getWorkflowServiceWSDL().then(() => {
        this._executeWorkflow(resolve, reject)
      })
    })
  }

  _executeWorkflow(resolve, reject) {
    // var payload = TeslSchema.INITIATE_QUOTE_DATA;
    var body = {
      request: {
        "operationLabel": "createCashTransferProfileObject",
        "serviceOpInvocationId": "ikk",//also try 18045
        "sessionId": this.sessionId,
        "contextObjectId": this.objectIDs["PolicyTransactionPolicy"]["os_st_id"],
        "actionId": '109745',
        'transactionId': this.sessionId
      }
    }

    this.workflowClient.call("executeWorkflow", body).subscribe(operation => {
      this.logResult('executeWorkflow', operation)
      resolve()
    })
  }

  updateObject(updateData, id_type = undefined) {
    return new Promise((resolve, reject) => {
      this.getObjectAccessServiceWSDL().then(() => {
        this._updateObject(resolve, reject, updateData, id_type)
      })
    })
  }

  _updateObject(resolve, reject, data, id_type) {
    var payload = data;
    var id = this.contextObjectId;
    if(id_type){
      id = this.objectIDs[id_type]["os_st_id"];
    }
    var body = {
      request: {
        "payload": this.objectAccessClient.wsdl.objectToXML(payload, "name"),
        "operationLabel": "updateQuote",
        "serviceOpInvocationId": "ikk",
        "sessionId": this.sessionId,
        "contextObjectId": this.contextObjectId
      }
    }

    var obs = this.objectAccessClient.call("updateObject", body)
    obs.subscribe(operation => {
      this.logResult('updateObject', operation)
      resolve(this.objectAccessClient.wsdl.xmlToObject(operation.result.return.payload))
    })
    return obs
  }

  tearDownSession() {
    return new Promise((resolve, reject) => {
      this.getSessionServiceWSDL().then(() => {
        this._tearDownSession(resolve, reject)
      })
    })
  }

  _tearDownSession(resolve, reject) {
    var body = {
      request: {
        sessionId: this.sessionId,
        operationLabel: "tearDownSession",
        systemId: "oneShield",
        serviceOpInvocationId: "1111111"
      }
    }

    var observable = this.sessionClient.call("tearDownSession", body)
    observable.subscribe(operation => {
      this.logResult('tearDownSession', operation)
      resolve()
    });
    return observable;
  }

}
